module.exports = __webpack_public_path__ + "img/nr-logo.9e3e5ebd.png";